<script setup lang="ts">
import VBackButton from '@components/buttons/VBackButton/VBackButton.vue';
import VCard from '@components/card/VCard/VCard.vue';
import VLoader from '@components/loader/VLoader.vue';
import {
  AFFILIATE_PROGRAM_SUB_AFFILIATE_DEALS_LIST_ROUTE_NAME,
  TRANSLATION_GROUP_AFFILIATE_PROGRAM_SUB_AFFILIATE_DEALS,
} from '@modules/affiliate-program-subaffiliate-deals/constants';
import SubAffiliateDeals from '@modules/affiliate-program-subaffiliate-deals/submodules/edit/components/SubAffiliateDeals/SubAffiliateDeals.vue';
import VForm from '@modules/forms/components/VForm/VForm.vue';

import { useAffiliateProgramSubAffiliateDealsEdit } from './composables';

const {
  isEdit,
  isLoading,
  formSchema,
  groups,
  constants,
  customErrors,
  isLoadingSave,
  item,
  clearError,
  onSubmit,
} = useAffiliateProgramSubAffiliateDealsEdit();
</script>

<template>
  <VCard v-data-qa-auto-id="'AffiliateProgramSubAffiliateDealsEditPage'"
    :title="$getTranslation(
      TRANSLATION_GROUP_AFFILIATE_PROGRAM_SUB_AFFILIATE_DEALS,
      isEdit ? 'HEADER_EDIT' : 'HEADER_CREATE',
    )"
    type="form"
  >
    <VLoader
      :loading="isLoading"
      min-height="200px"
    >
      <VForm
        :schema="formSchema"
        :groups="groups"
        :submit-btn-label="$getTranslation(TRANSLATION_GROUP_AFFILIATE_PROGRAM_SUB_AFFILIATE_DEALS, 'BTN_SAVE')"
        :custom-errors="customErrors"
        :is-loading="isLoadingSave"
        :readonly="item?.read_only"
        @interacted="clearError"
        @submit="onSubmit"
      >
        <template #subaffiliate_condition_steps_attributes="{ className, errors, readonly, onChange, onBlur }">
          <SubAffiliateDeals
            :item="item"
            :payment-options="constants"
            :errors="errors"
            :readonly="readonly"
            :class="className"
            @change="onChange('subaffiliate_condition_steps_attributes', $event)"
            @blur="onBlur('subaffiliate_condition_steps_attributes', $event)"
          />
        </template>
        <template #secondaryBtn>
          <VBackButton
            :label="$getTranslation(TRANSLATION_GROUP_AFFILIATE_PROGRAM_SUB_AFFILIATE_DEALS, 'BTN_BACK')"
            :to="{ name: AFFILIATE_PROGRAM_SUB_AFFILIATE_DEALS_LIST_ROUTE_NAME }"
            :loading="isLoadingSave"
          />
        </template>
      </VForm>
    </VLoader>
  </VCard>
</template>
